import React, { useState } from "react";
import { Badge, Button, Col, Form, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Filter } from "react-feather";
import Select from "react-select";
import { addDefaultOption } from "../../../../../utils/utility";
import { DatePicker } from "antd";
import moment from "moment";

const reasonOptions = addDefaultOption([
    {
        value: "refund",
        label: "Refund",
    },
    {
        value: "write_off",
        label: "Write Off",
    },
]);

const Search = ({ setSearchValue, searchValue, search, createdByList, approvedByList }) => {
    return (
        <div className="py-3">
            <Row className="g-2 mb-2">
                <Col md={3}>
                    <Form.Control
                        type="text"
                        name="invoice_number"
                        placeholder="Invoice number"
                        size="lg"
                        value={searchValue.invoice_number || ""}
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                invoice_number: event.target.value,
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <Select
                        isClearable
                        className="react-select-container render-above-1"
                        classNamePrefix="react-select"
                        placeholder="Created By"
                        options={addDefaultOption(createdByList)}
                        name="requestor_name"
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                requestor_name: event?.value || "",
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <Select
                        isClearable
                        className="react-select-container render-above-1"
                        classNamePrefix="react-select"
                        placeholder="Approved By"
                        options={addDefaultOption(approvedByList)}
                        name="approver_name"
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                approver_name: event?.value || "",
                            });
                        }}
                    />
                </Col>
                <Col md={3}>
                    <Select
                        isClearable
                        className="react-select-container render-above-1"
                        classNamePrefix="react-select"
                        placeholder="Status"
                        options={addDefaultOption([
                            {
                                value: "PENDING",
                                label: "Pending",
                            },
                            {
                                value: "APPROVED",
                                label: "Approved",
                            },
                            {
                                value: "REJECTED",
                                label: "Rejected",
                            },
                        ])}
                        name="status"
                        value={searchValue.status ? { value: searchValue.status, label: searchValue.status } : null}
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                status: event?.value,
                            });
                        }}
                    />
                </Col>
                 <Col md={3}>
                    <Select
                        isDisabled={true}
                        isClearable
                        className="react-select-container render-above-1"
                        classNamePrefix="react-select"
                        placeholder="Reason"
                        options={reasonOptions}
                        name="reason"
                        value={
                            searchValue.reason && searchValue.reason !== ''
                                ? addDefaultOption([
                                    { value: 'refund', label: 'Refund' },
                                    { value: 'write_off', label: 'Write Off' },
                                ]).find(({ value }) => value === searchValue.reason)
                                : null
                        }
                        onChange={(event) => {
                            setSearchValue({
                                ...searchValue,
                                reason: event?.value,
                            });
                        }}
                    />
                </Col>
            </Row>

            <Row className="row-flex g-2">
                <Col md={6}>
                    <Row className="flex-row flex-row ms-md-1">
                        <Col md={5} sm={12} className="p-md-0">
                            <DatePicker
                                id="approved-from-date-picker"
                                name="approved_start_date"
                                className={`form-control`}
                                placeholder="Approved from date"
                                value={searchValue.approved_start_date ? moment(searchValue.approved_start_date) : null}
                                onChange={(event) => {
                                    setSearchValue({
                                        ...searchValue,
                                        approved_start_date: event ? moment(event).format("YYYY-MM-DD") : null,
                                    });
                                }}
                                style={{minHeight: '2.5rem'}}
                            />
                        </Col>
                        <Col md={2} className="d-flex align-items-center justify-content-center m-0 p-0">
                            <Badge bg='info' className="d-flex align-items-center justify-content-center text-center w-100 h-100 mx-2 mx-md-0">
                                To
                            </Badge>
                        </Col>
                        <Col md={5} className="p-md-0">
                            <DatePicker
                                id="approved-to-date-picker"
                                name="approved_end_date"
                                className={`form-control`}
                                placeholder="Approved to date"
                                value={searchValue.approved_end_date ? moment(searchValue.approved_end_date) : null}
                                onChange={(event) => {
                                    setSearchValue({
                                        ...searchValue,
                                        approved_end_date: event ? moment(event).format("YYYY-MM-DD") : null,
                                    });
                                }}
                                style={{minHeight: '2.5rem'}}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={6} className="d-flex justify-content-md-end justify-content-center p-0">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-top`}>Search filter</Tooltip>}
                    >
                        <Button className="" size="lg" variant="info" onClick={() => search()} title="Search filter">
                            <Filter size={15} />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Row>
        </div>
    );
};

export default Search;